module.exports = __webpack_public_path__ + "static/background2-e03599ab9ddcec98915f9bc2e75cd93b.svg";